export default __webpack_public_path__ + "static/building-expand-8b0b7f987dd951e92c2a1eac0fe3f0d7.mp4";